declare const CONFIG: {
  recaptcha_enabled: boolean;
  recaptcha_site_key: string;
};

export const RECAPTCHA_ENABLED = CONFIG.recaptcha_enabled;
export const RECAPTCHA_SITE_KEY = CONFIG.recaptcha_site_key;
